var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "mb-0", class: _vm.leftSideClass },
      [_c("title-bread-crumb", { attrs: { page: _vm.page } })],
      1
    ),
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-end align-items-center actions",
        class: _vm.rightSideClass
      },
      [
        _vm._t("custom_actions"),
        _vm.hasReturn
          ? _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-arrow-circle-left",
                  variant: "outline-success m-2"
                },
                on: { click: _vm.onReturn }
              },
              [_vm._v(" Regresar ")]
            )
          : _vm._e(),
        _vm.hasSave
          ? _c(
              "action-button",
              {
                attrs: { i: `fas fa-save pr-1`, variant: "success" },
                on: { click: _vm.save }
              },
              [_vm._v(" Guardar ")]
            )
          : _vm._e(),
        _vm.hasAdd
          ? _c(
              "action-button",
              {
                attrs: { i: `fas fa-file-plus pr-1`, variant: "success" },
                on: { click: _vm.add }
              },
              [_vm._v(" " + _vm._s(_vm.addText) + " ")]
            )
          : _vm._e(),
        _vm.hasSubmit
          ? _c(
              "action-button",
              {
                attrs: {
                  disabled: _vm.submitDisabled,
                  i: `fas fa-save pr-1`,
                  variant: "success"
                },
                on: { click: _vm.submit }
              },
              [_vm._v(" Someter ")]
            )
          : _vm._e(),
        _vm.hasPrint
          ? _c(
              "action-button",
              {
                staticClass: "m-2",
                attrs: {
                  disabled: _vm.printDisabled,
                  i: `fas fa-print pr-1`,
                  variant: "success"
                },
                on: { click: _vm.print }
              },
              [_vm._v(" Imprimir ")]
            )
          : _vm._e(),
        _vm.hasInfo
          ? _c(
              "action-button",
              {
                staticClass: "m-2 btn btn-dropdown-actions px-4",
                attrs: {
                  disabled: _vm.infoDisabled,
                  iright: "fas fa-angle-down",
                  variant: "success"
                },
                on: { click: _vm.info }
              },
              [_vm._v(" Informes ")]
            )
          : _vm._e(),
        _vm.hasAssingProposal
          ? _c(
              "action-button",
              {
                staticClass: "m-2",
                attrs: {
                  disabled: _vm.assignProposalDisabled,
                  i: `fas fa-clone pr-1`,
                  variant: "success"
                },
                on: { click: _vm.assignProposal }
              },
              [_vm._v(" Asignar Propuestas ")]
            )
          : _vm._e(),
        _vm.hasEvaluators
          ? _c(
              "action-button",
              {
                attrs: {
                  disabled: _vm.evaluatorsDisabld,
                  i: `fas fa-users pr-1`,
                  variant: "success m-2 pr-3"
                },
                on: { click: _vm.evaluators }
              },
              [_vm._v(" Evaluadores ")]
            )
          : _vm._e(),
        _vm.hasContinue
          ? _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-arrow-circle-right pr-1",
                  variant: "success"
                },
                on: { click: _vm.onContinue }
              },
              [_vm._v(" Continuar ")]
            )
          : _vm._e()
      ],
      2
    ),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", {
        staticClass: "dropdown-divider mt-0 pb-2 w-102 mb-4 ml-n5 mr-n5"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }